export enum DataSetPref {
	ENABLED = 'dataManager.enabled',
	MIN_USER_LEVEL = 'dataManager.minUserLevel',
}
